



































































































































































































































































import Vue from "vue";
import AvatarCard from "@/components/AvatarCard.vue";
import InfoCard from "@/components/InfoCard.vue";
import PearlString from "@/components/PearlString.vue";
import TextLengthRestriction from "@/components/TextLengthRestriction.vue";
import PrimaryInfo from "@/modals/PrimaryInfo.vue";
import SkillsInfo from "@/modals/SkillsInfo.vue";
import ServiceNeed from "@/modals/ServiceNeed.vue";
import KykyviisariGraphs from "@/modals/KykyviisariGraphs.vue";
//import LinkPearl from "@/components/LinkPearl.vue";
import { format, parseISO } from "date-fns";
import axios from "axios";
import store from "@/store";
import router from "@/router";

export default Vue.extend({
	components: {
		AvatarCard,
		InfoCard,
		PrimaryInfo,
		SkillsInfo,
		ServiceNeed,
		KykyviisariGraphs,
		TextLengthRestriction,
		PearlString
		//LinkPearl
	},
	data() {
		return {
			worker: {} as any,
			aml: [] as any,
			maat: [] as any,
			steps:[] as any,
			keywords: [] as any,
			customershipActions: [],
			latestKykyviisariDate: "",
			latestServiceRequirement: {} as any,
			additionalInfoShown: false as boolean,
			serviceRequirementLoading: true as boolean
		};
	},
	methods: {
		getWorkerData() {
			axios.get("Itsepalvelu/user").then((resp) => {
				this.worker = resp.data;
				if (this.worker !== null && this.worker !== undefined) {

					axios
						.get(`itsepalvelu/user/steps/${this.worker.uid}`)
						.then((resp) => {
							this.steps = resp.data;
					});

					axios.get(`keywords/basicprofilekeywords/${false}`).then((r) => {
						this.keywords = r.data.sort((a: any,b: any) => a.displayName.toLowerCase() < b.displayName.toLowerCase() ? -1 : 1);
						
					});

					axios
						.get(`Itsepalvelu/customershipactions/${this.worker.uid}`)
						.then((r) => {
							this.customershipActions = r.data;
						});

					axios
						.get(`palvelutarpeenarviointi/serviceRequirements/${this.worker.uid}`)
						.then((resp) => {
							if(resp.data.length > 0){
								this.latestServiceRequirement = resp.data[0];
							}
							this.serviceRequirementLoading = false;
					});
				}
			});
		},
		// get all organization ammattiluokitukset
		getAml() {
			axios.get(`Itsepalvelu/aml`).then((resp) => {
				resp.data.forEach((a: any) => {
					this.aml.push(a);
				});
			});
		},
		vocTranslate(voc : any) {
			switch (this.$store.state.lang) {
				case 'fi':
					return voc.nimi;
				case 'en': 
					return voc.nimiEnglanti ? voc.nimiEnglanti : voc.nimi as string
				case 'se':
					return voc.nimiRuotsi ? voc.nimiRuotsi : voc.nimi as string
				default:
					return voc.nimi as string
			}
		},
		//maaluettelo
		getCountries() {
			axios.get("Itsepalvelu/countries").then((resp) => {
				resp.data.forEach((m: any) => {
					this.maat.push(m);
				});
			});
		},
		primaryUpdate(uWorker: {}) {
			this.worker = uWorker;
			axios
				.put("Itsepalvelu/user/update", { ...uWorker })
				.then(() => {
					this.makeToast("success");
				})
				.catch((ex) => {
					console.log(ex);
				});
		},
		makeToast(s: string) {
			let msg = this.$t("updated") as string;
			this.$bvToast.toast(msg, {
				variant: s,
				solid: true,
				toaster: "b-toaster-top-center",
			});
		},
		primaryUpdateModal() {
			this.$bvModal.show("primary-info");
		},
		showSecondaryModal() {
			this.$bvModal.show("secondary-info");
		},
		editServiceNeedModal() {
			this.$bvModal.show("service-need");
		},
		skillsModal() {
			this.$bvModal.show("skills-info");
		},
		goToAbiPage() {
			router.push({
				name: "Kykyviisari",
				params: {
					org: store.state.org as string,
				},
			});
		},
		setKykyviisariDate(date: string) {
			this.latestKykyviisariDate = format(parseISO(date), "dd.M.yyyy");
		},
		formatPostalAddress(
			postiosoite: string,
			postinumero: string,
			postitoimipaikka: string
		) {
			var address = "";
			if (postiosoite + "" !== "" && postiosoite !== null) {
				address = postiosoite;
			}

			if (
				(postinumero + "" !== "" && postinumero !== null) ||
				(postitoimipaikka + "" !== "" && postitoimipaikka !== null)
			) {
				if (address + "" !== "") {
					address = address + ", ";
				}
				if (postinumero + "" !== "" && postinumero !== null) {
					address = address + postinumero + " ";
				}
				if (postitoimipaikka + "" !== "" && postitoimipaikka !== null) {
					address = address + postitoimipaikka;
				}
			}
			return address;
		},

		formatSituation(situation: number){
			if(situation === 1){
                return "yes"
            }else if(situation === 2){
                return "service-requirement-modal.some-changes"
            }else if(situation === 3){
				return "service-requirement-modal.changes"
			}else{
				return "dash"
			}
		},

		formatDate(date: any){
			let parsed = parseISO(date);
			return format(parsed, 'dd.MM.yyyy');
		},

		generateChoicesString(){
			const {palvelutarpeenArvioinninMuutosValinnat} = this.latestServiceRequirement;

			if(Object.keys(this.latestServiceRequirement).length <= 0){
				return "";
			}

			const correntLanguages: any[] = palvelutarpeenArvioinninMuutosValinnat.map((r: any) => {
				if(this.$store.state.lang === 'en'){
					return {
						uid: r.uid,
						text: r.tekstiEnglanti
					}
				}else if(this.$store.state.lang === 'se'){
					return {
						uid: r.uid,
						text: r.tekstiRuotsi
					}
				}else{
					return {
						uid: r.uid,
						text: r.teksti
					}
				}
			})

			return correntLanguages.map(r => r.text).join(", \n");
		},

		enterServiceRequirementPage() {
			if (store.state.isMobile) {
				this.$emit("closePanel")
			}
			this.$router.push({name: 'ServiceRequirement', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
		},
	},
	async created() {
		this.getWorkerData();
		this.getAml();
		this.getCountries();
		await this.$nextTick();
	},
	computed: {
		isMobile() {
         return store.state.isMobile;
      },      
      storeAuthObject() {
			return this.$store.state.strongAuth;
		},
		storeJwt() {
			return this.$store.state.jwt;
		},
		storeOrgServices() {
			return this.$store.state.orgServices;
		},
		formattedDob() {
			return format(parseISO(this.$store.state.strongAuth.Dob), "dd.M.yyyy");
		},
		workerdata() {
			return this.$data.worker;
		},
		amldata() {
			return this.$data.aml;
		},
		abilitatorEnabled() {
			return this.$store.state.orgServices.includes("kykyviisari");
		},
		headaiEnabled() {
			return this.$store.state.orgServices.includes("headai");
		},
		serviceRequirementEnabled(){
			return this.$store.state.orgServices.includes("palvelutarpeenarviointi");
		},
      headaiJobsEnabled() {
			return this.$store.state.orgServices.includes("työpaikkasuositukset");
		}
	},

	watch: {
		storeJwt: {
			handler: async function handle(newVal) {
				if (newVal) {
					try {
						const resp = await axios.get("auth/TestAuth");
						console.log(resp);
					} catch (error) {
						router.push({
							name: "Home",
							params: {
								org: store.state.org as string,
							},
						});
					}
				} else {
					router.push({
						name: "Home",
						params: {
							org: store.state.org as string,
						},
					});
				}
			},
			immediate: true,
		},
	},
});
